export default {"src":"/_next/static/media/tripadvisor.00bca14f.svg","height":76,"width":80,"blurWidth":0,"blurHeight":0};